export enum FontWeight {
  light = '300',
  regular = '400',
  medium = '500',
  semibold = '600',
  bold = '700',
  heavy = '800'
}
